export const LOAD_CONTENT_BY_CAT_SLUG =
  'editorAC/CategoryPageContainer/LOAD_CONTENT_BY_CAT_SLUG';

export const LOAD_CONTENT_BY_CAT_SLUG_SUCCESS =
  'editorAC/CategoryPageContainer/LOAD_CONTENT_BY_CAT_SLUG_SUCCESS';

export const CATEGORIES_INDIVIDUAL_SLUG = [
  'presentation',
  'twitter-header',
  'instagram-post',
  'poster',
  'new-year-card',
  'infographic',
  'planner',
  'calendar',
];

export const CATEGORIES_SORT_RANDOM = ['logo'];

export const LIST_SLUGS_SHOW_TAG = [
  'flyer',
  'poster',
  'shop-card',
  'greeting-card',
  'instagram-post',
];
